import Vue from 'vue';
import Vuex from 'vuex';
import home from './modules/home'; // 确保路径正确
import user from './modules/user'; // 确保路径正确

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    home, // 注册 home 模块
    user
  }
});

export default store;